import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { Container, Toolbar } from '@mui/material';
import useAccounts from 'context/useAccounts';
import { getRouteId } from 'i18n';

import Link from 'components/link/Link';
import { AppRoutes } from 'routes';

const MenuBar = () => {
    const { formatMessage } = useIntl();
    const { accounts } = useAccounts();
    const { pathname } = useLocation();

    const links = [
        {
            disabled: false,
            id: 'tab.label.accounts',
            routeId: AppRoutes.accounts,
        },
        {
            disabled: !Boolean(accounts?.length),
            id: 'tab.label.estatement',
            routeId: AppRoutes.eStatements,
        },
        {
            disabled: !Boolean(accounts?.length),
            id: 'tab.label.profile',
            routeId: AppRoutes.profile,
        },
    ];

    return (
        <Toolbar className="menu-container">
            <Container className="menu" maxWidth="false">
                {links.map((linkItem, i) => (
                    <Link
                        aria-label={formatMessage({
                            id: linkItem.id,
                        })}
                        className={getRouteId(pathname).includes(linkItem.routeId) ? 'active' : ''}
                        disabled={linkItem.disabled}
                        key={linkItem.routeId + i}
                        to={linkItem.routeId}
                    >
                        <FormattedMessage id={linkItem.id} />
                    </Link>
                ))}
            </Container>
        </Toolbar>
    );
};

export default MenuBar;
